import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'unite-complete-dialog',
    templateUrl: './complete-dialog.component.html',
    styleUrls: ['./complete-dialog.component.scss'],
    imports: [MatDialogTitle, TranslateModule, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class CompleteDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public message: string) { }

}